'use client'

import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch } from '@/store'
import {
  setBeforePath,
  clearBeforePath,
  setTwitterLogin,
  clearTwitterLogin,
  selectBeforePath,
  selectTwitterLogin,
} from '@/store/navigation/slice'

export function useNavigationState() {
  const dispatch = useDispatch<AppDispatch>()
  const beforePath = useSelector(selectBeforePath)
  const twitterLogin = useSelector(selectTwitterLogin)

  const saveBeforePath = (path: string) => {
    dispatch(setBeforePath(path))
  }

  const removeBeforePath = () => {
    dispatch(clearBeforePath())
  }

  const saveTwitterLogin = (value: boolean) => {
    dispatch(setTwitterLogin(value))
  }

  const removeTwitterLogin = () => {
    dispatch(clearTwitterLogin())
  }

  return {
    beforePath,
    twitterLogin,
    saveBeforePath,
    removeBeforePath,
    saveTwitterLogin,
    removeTwitterLogin,
  }
}
